module.exports = __webpack_public_path__ + "static/media/Head1.46c65df4.svg";